import { Expandable } from '@warp-ds/react';
import type { PropsWithChildren } from 'react';

type FilterGroupProps = {
    title: string;
    expanded?: boolean;
    testId?: string;
    borderTop?: boolean;
};

export const FilterGroup = ({ title, children, expanded = true, borderTop = true, ...otherProps }: PropsWithChildren<FilterGroupProps>) => (
    <div className={`${borderTop ? 'border-t' : ''}`}>
        <Expandable box animated expanded={expanded} style={{ backgroundColor: 'transparent' }} title={title} {...otherProps}>
            {children}
        </Expandable>
    </div>
);
